// extracted by mini-css-extract-plugin
export default {"wrapper":"Preview_wrapper__N3IpW","holder":"Preview_holder__dt9KC","playWrapper":"Preview_playWrapper__v9LOx","icon":"Preview_icon__00LZn"};